import { FormatPhonePipe } from '../../../../../modules/mapfre-design-library/src/lib/_helpers/_pipes/format-phone.pipe';
import { BnImpNoticeComponent } from './bn-imp-notice/bn-imp-notice.component';
import { BnErrorNoticeComponent } from './bn-error-notice/bn-error-notice.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, BnErrorNoticeComponent, BnImpNoticeComponent, FormatPhonePipe],
  selector: 'app-bn-notice',
  templateUrl: './bn-notice.component.html',
  styleUrls: ['./bn-notice.component.scss']
})
export class BnNoticeComponent implements OnInit {
  @Input() policy: any;
  hideAlert: boolean;
  hideAffinityAlert: boolean;
  agentPhoneNumber: string;
  agentName: string;
  isAcmic: boolean; 

  constructor(
    private acmicService: AcmicService
  ) {
    this.hideAlert = false;
    this.hideAffinityAlert = false;
    this.isAcmic = this.acmicService.isACMIC();
   }

  onClose() {
    this.hideAlert = true;
  }
  onAffinityClose() {
    this.hideAffinityAlert = true;
  }
  ngOnInit(): void {
    this.agentPhoneNumber = this.policy?.agent?.agentISCPhone && this.policy?.agent?.agentISCPhone?.number
                              ? this.policy?.agent?.agentISCPhone?.number
                              : this.policy?.agent?.agentPhone?.number
    this.agentPhoneNumber = this.agentPhoneNumber?.toString().replace(/\D+/g, '');
    this.agentName = this.policy?.agent?.agentName;
  }

}
